var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnupreethaLogoViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 65,
    viewBox: "0 0 74 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.946815 51L4.51615 14.0469H17.0508L20.5572 51H13.5655L13.0406 45.0371H8.58939L8.12748 51H0.946815ZM9.1143 39.1372H12.4737L10.857 20.3457H10.521L9.1143 39.1372ZM23.9888 51V19.5059H31.5054V23.5161C31.7853 22.3123 32.3032 21.2905 33.0591 20.4507C33.8289 19.5968 34.8927 19.1699 36.2505 19.1699C38.4341 19.1699 40.0158 19.8418 40.9956 21.1855C41.9894 22.5293 42.4863 24.37 42.4863 26.7075V51H35.0747V27.4844C35.0747 26.8685 34.9487 26.3016 34.6968 25.7837C34.4448 25.2518 34.0109 24.9858 33.395 24.9858C32.8211 24.9858 32.3942 25.1888 32.1143 25.5947C31.8483 25.9867 31.6803 26.4836 31.6104 27.0854C31.5404 27.6733 31.5054 28.2612 31.5054 28.8491V51H23.9888ZM52.8046 51.3359C51.125 51.3359 49.8372 50.986 48.9414 50.2861C48.0595 49.5863 47.4576 48.6134 47.1357 47.3677C46.8138 46.1079 46.6528 44.6382 46.6528 42.9585V19.5059H54.2114V42.0767C54.2114 43.3364 54.3094 44.2183 54.5053 44.7222C54.7013 45.2121 55.1632 45.457 55.8911 45.457C56.6749 45.457 57.1648 45.1071 57.3608 44.4072C57.5708 43.7074 57.6757 42.8045 57.6757 41.6987V19.5059H65.1713V51H57.6547V47.6406C57.1788 48.8444 56.6049 49.7612 55.9331 50.3911C55.2752 51.021 54.2324 51.3359 52.8046 51.3359Z",
    fill: "#202020"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 47.5,
    r: 3.5,
    fill: "#8A2BE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnupreethaLogoViolet);
export default __webpack_public_path__ + "static/media/anupreetha-logo-violet.e7f2ac6842170012ebe6085b6b047176.svg";
export { ForwardRef as ReactComponent };